import { render, staticRenderFns } from "./PushNotification.vue?vue&type=template&id=c6bb082e&scoped=true&"
import script from "./PushNotification.vue?vue&type=script&lang=js&"
export * from "./PushNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bb082e",
  null
  
)

export default component.exports